import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { UserModel } from 'src/app/shared/models/user.model';
import { UserService } from 'src/app/shared/services/user.service';
import { RegistrationComponent } from '../registration/registration.component';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['fullName', 'userName', 'role', 'countryCode', 'email', 'phoneNumber', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  dialogConfig = new MatDialogConfig();

  constructor(private service : UserService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router,
    private dialog : MatDialog ) {

      console.log("IssueListComponent ");


      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "50%";
      this.dialogConfig.minWidth = "400px";
      this.dialogConfig.maxWidth = "600px";

    }

  ngOnInit() {
    this.refreshList();
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this user?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "User Delete");
        this.gnotify.showSnackBar('User Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
      this.service.getUserList().subscribe(
        res => {
          let array = res as UserModel[];
          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;

          console.log("refreshList : " + this.thisData.data.length);
          this.applyFilter()
        },
        err =>{
          console.log(err);
        }
      );
  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {

    if(this.searchKey == null) return;
    console.log("applyFilter");
    this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
    this.service.initializeFormGroup();
    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(RegistrationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();

      }

    });
  }

  onEdit(row){
    this.service.populateForm(row);

    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(RegistrationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();

      }

    });
  }
/*
  onCreate()
  {
    //this.router.navigateByUrl('/issue-detail');
    this.onSelected.emit();
  }

  onEdit(row){
    //this.router.navigateByUrl('/issue-detail?id=' + row.issueId);
    this.onSelected.emit(row);
  }
 */

}
